import * as ACT from '../actions/reportActions';

export function report(state = {}, action) {
    switch (action.type) {


        case ACT.POS_SET_ALL:
            return {
                ...state,
                posList: action.data,
            };
        case ACT.TECHNICIAN_SET_ALL:
            return {
                ...state,
                technicianList: action.data,
            };
        case ACT.CITY_SET_ALL:
            return {
                ...state,
                cityList: action.data,
            };
        case ACT.RATE_SET_ALL:
            return {
                ...state,
                rateList: action.data,
            };



        default:
            return state
    }
};
